export default "__VITE_ASSET__v41FZg7p__"